import React, { FC } from 'react';
import { StyledCross } from './Cross.styles';
import { ICross } from './Cross.type';

const Cross: FC<ICross> = ({ withBlurBackground = false }) => {
	return (
		<StyledCross withBlurBackground={withBlurBackground}>
			<span />
			<span />
		</StyledCross>
	);
};

export { Cross };
